import { render, staticRenderFns } from "./Float.vue?vue&type=template&id=408ed029&"
import script from "./Float.vue?vue&type=script&lang=js&"
export * from "./Float.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/Product.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports